import { Fragments } from '@ciceksepeti/cs-module-loader';
import { matchPath } from 'react-router-dom';
import Routings from '@lookups/routings';
var SHELL_SCOPE = 'ciceksepetiShell';
var resolveScopeFromPathname = function (pathname) {
    for (var _i = 0, Routings_1 = Routings; _i < Routings_1.length; _i++) {
        var route = Routings_1[_i];
        for (var _a = 0, _b = route.paths; _a < _b.length; _a++) {
            var path = _b[_a];
            if (matchPath({ path: path, end: true }, pathname)) {
                return route.scope;
            }
        }
    }
    return null;
};
export var getFragmentName = function (pathname) {
    var _a;
    if (pathname === void 0) { pathname = window.location.pathname; }
    var routeScope = resolveScopeFromPathname(pathname);
    var scope = routeScope !== null && routeScope !== void 0 ? routeScope : SHELL_SCOPE;
    var fragment = Fragments.get(scope);
    if (!fragment && !routeScope)
        return '';
    var label = typeof (fragment === null || fragment === void 0 ? void 0 : fragment.scope) === 'string' && fragment.scope ? fragment.scope : scope;
    var rawVersion = (_a = fragment === null || fragment === void 0 ? void 0 : fragment.version) !== null && _a !== void 0 ? _a : fragment === null || fragment === void 0 ? void 0 : fragment.latestVersion;
    var version = typeof rawVersion === 'string' || typeof rawVersion === 'number' ? String(rawVersion) : '';
    if (!version)
        return label;
    return "".concat(label, "-").concat(version);
};
